import {
  MDBChip,
  MDBDatepicker,
  MDBInput,
  MDBTextArea,
} from "mdb-react-ui-kit";
import React from "react";

function TransferNumbers({
  register,
  errors,
  watch,
  setValue,
  clearErrors,
  portingType,
}) {
const filterFunction = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize current date to midnight for accurate comparison

    // Function to check if a date is a weekday (business day)
    const isBusinessDay = (day) => day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday

    // Function to add business days to a date
    const addBusinessDays = (startingDate, businessDaysToAdd) => {
      let count = 0;
      const currentDate = new Date(startingDate);

      while (count < businessDaysToAdd) {
        currentDate.setDate(currentDate.getDate() + 1);
        if (isBusinessDay(currentDate.getDay())) {
          count++;
        }
      }

      return currentDate;
    };

    // Step 1: Calculate the date after 7 business days
    let futureDate = addBusinessDays(today, 7);

    // Step 2: If the 7th business day falls on a weekend, move to next business day
    // Saturday (6) -> add 2 days to get to Monday
    // Sunday (0) -> add 1 day to get to Monday
    if (futureDate.getDay() === 6) { // Saturday
      futureDate.setDate(futureDate.getDate() + 2);
    } else if (futureDate.getDay() === 0) { // Sunday
      futureDate.setDate(futureDate.getDate() + 1);
    }

    // Disable the current date and any dates before the future date
    if (date < futureDate) {
      return false; // Disable this date
    }

    return true; // Enable all other dates
  };

  return (
    <>
      {parseInt(portingType) !== 3 ? (
        <div className="ps-3">
          <div className="overflow-auto h-100">
            <h5>Enter Number(s)</h5>
            <p>
              <b>Numbers to Transfer*</b>
            </p>
            {/* <MDBTextArea id='textAreaExample' rows={2} /> */}
            {/* <div className="border p-2">
      {parseInt(portingType) !== 3 ? (
        <div className="overflow-auto h-100">
          <h5>Enter Number(s)</h5>
          <p>
            <b>Numbers to Transfer</b>
          </p>
          {/* <MDBTextArea id='textAreaExample' rows={2} /> */}
            {/* <div className="border p-2">
          <div className="d-flex mb-2 numberchips">
            <MDBChip closeIcon>+1 123 456 7788</MDBChip>
            <MDBChip closeIcon>+1 123 456 7788</MDBChip>
            <MDBChip closeIcon>+1 123 456 7788</MDBChip>
          </div>
          <MDBInput />
        </div> */}

            <MDBTextArea
              className="tn-textarea"
              id="textAreaExample"
              rows={4}
              value={watch("enter_num.number")}
              onChange={(e) => {
                clearErrors("enter_num.number");
                setValue("enter_num.number", e.target.value, {
                  shouldDirty: true,
                });
              }}
            //   placeholder="Enter your comments"
            />
            {errors?.enter_num?.number && (
              <p className="text-danger">{errors?.enter_num?.number?.message}</p>
            )}

            <p className="mt-2">
              Enter phone numbers range(for ex 8002345100-8099, here all 3000 phone
              numbers will be taken) or enter all phone numbers separated with a
              space, comma, tab or can be added in a new line.
            </p>
            <div className="mt-2">
              {/* <p>Desired Due Date</p> */}
              <div className="w-30 mob-w-100">
                <MDBDatepicker
                  disablePast
                  filter={filterFunction}
                  inline
                  inputLabel="Desired Due Date*"
                  format="mm/dd/yyyy"
                  value={watch("enter_num.ddd")}
                  onChange={(value) => {
                    if(value && value !== "") {
                    clearErrors("enter_num.ddd");
                    setValue("enter_num.ddd", value, { shouldDirty: true });
                    }
                  }}
                // {...register("enter_num.ddd", { require: "Date is required" })}
                />
                {errors?.enter_num?.ddd && (
                  <p className="text-danger">{errors?.enter_num?.ddd?.message}</p>
                )}
              </div>
              <p className="mt-2 small">
                We cannot assure the port will occur on this date
              </p>
            </div>
            <div className="mt-3">
              <b>Following are the steps for TN/TFN Porting:</b>
              <ol className="mt-2">
                <li>
                  Enter the TN/TFN that you want to Port-In. A Maximum of 3000
                  numbers can be added at a time.
                </li>
                <li>
                  Review added number. Click the Edit Number button to edit added
                  field.
                </li>
                <li>Assign Number(s) to Respective Destination(s)</li>
                <li>Enter Account Info and Enter Service Address.</li>
                <li>Add a comment if you want to specify anything.</li>
                <li>Fill checklist.</li>
                <li>Upload a copy of the latest bill for entered numbers.</li>
                <li>
                  Select checkbox in the LOA section, and Click Submit button to
                  submit the order request.
                </li>
                <li>Check confirmation message.</li>
              </ol>
              <p className="mt-2">
                Once you placed the order, you can check the order status in Admin
                Dashboard. Also, you will be notified through email for every
                update in your order request.
              </p>
              <p className="mt-2">
                <b>Note:</b>
              </p>

              <ol>
                <li>
                  {" "}
                  Please note that the porting interval is 7-10 business days
                  (from the time we receive your updated information) for ports
                  under 100 numbers, and can take up to 30 business days for 100
                  numbers or more. We make every effort to transfer your numbers
                  to Streams in a timely manner.
                </li>
                <li>
                  {" "}
                  If a federal holiday is chosen, then the order will not be
                  rejected, instead, the order will receive a FOC date for the
                  next business day after the holiday.
                </li>
                <li>
                  {" "}
                  The Desired Due Date is tentative until a Firm Order Commitment
                  (FOC) date is received
                </li>
              </ol>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="ps-3">
            <div className="overflow-auto h-100">
              <h5>Enter Number(s)</h5>
              <p>
                <b>Numbers to Validate</b>
              </p>
              {/* <MDBTextArea id='textAreaExample' rows={2} /> */}
              {/* <div className="border p-2">
          <div className="d-flex mb-2 numberchips">
            <MDBChip closeIcon>+1 123 456 7788</MDBChip>
            <MDBChip closeIcon>+1 123 456 7788</MDBChip>
            <MDBChip closeIcon>+1 123 456 7788</MDBChip>
          </div>
          <MDBInput />
        </div> */}

              <MDBTextArea
                id="textAreaExample"
                rows={4}
                value={watch("enter_num.number")}
                onChange={(e) => {
                  clearErrors("enter_num.number");
                  setValue("enter_num.number", e.target.value, {
                    shouldDirty: true,
                  });
                }}
              //   placeholder="Enter your comments"
              />
              {errors?.enter_num?.number && (
                <p className="text-danger">
                  {errors?.enter_num?.number?.message}
                </p>
              )}

              <p className="mt-2">
                Enter phone numbers separated with a space, comma, tab or can be
                added in a new line.
              </p>
            </div>
            <div className="mt-3">
              <b>Following are the steps for Telephone Number Validation:</b>
              <ol className="mt-2">
                <li>
                  Enter the Telephone number(s) that you want to validate for
                  caller ID purposes(Maximum of 200 phone numbers can be added at
                  a time).
                </li>
                <li>
                  Review added number. Click the Edit Number button to edit added
                  field or click Next to proceed.
                </li>
                <li>
                  {" "}
                  Fill Enter Account Info and Enter Service Address optional
                  fields and click Next or click Skip to skip and proceed.
                </li>
                <li>
                  Upload a copy of the current bill to support that you own the
                  mentioned phone number(s) and click Next.
                </li>
                <li>
                  Select the check box in the LOA section, and click Submit button
                  to complete the submission.
                </li>
                <li>
                  Check confirmation message. You can use the validated telephone
                  number(s) for caller ID purposes.
                </li>
              </ol>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default TransferNumbers;
